import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import axiosInstance from '../../../services/axiosComman';
import logout from '../../../utils/Logout';
import { GetAccess, GetRole } from '../../../utils/RolesandAccess';
import Hourglass from '../../../utils/HourGlass';


const Toast = Swal.mixin({
  toast: true,
  position: 'bottom-end',
  showConfirmButton: false,
  timer: 4000,
  timerProgressBar: true,
  didOpen: (toast) => {
    toast.addEventListener('mouseenter', Swal.stopTimer);
    toast.addEventListener('mouseleave', Swal.resumeTimer);
  },
});

function ViewMore({ data,fetcher }) {
  const [isLoading, setLoading] = useState(false)
  const [isDownloadLoading, setDownloadLoading] = useState(false)
  const [filePath, setFilePath] = useState('');
  const fetchFilePath = async () => {
    
    let value = ""
    let dataLink = data?.file_url;

    if(dataLink.includes('Manual_backups')){
      value = dataLink.replace("Backups/Manual_backups","Auth/Manual_backups")
    }else if(dataLink.includes('Upload_backups')){
      value = dataLink.replace("Backups/Upload_backups","Auth/Upload_backups")

    }else if(dataLink.includes('Auto_backups')){
      value = dataLink.replace("Backups/Auto_backups","Auth/backups")
    }

    try {
      const response = await fetch(value);
      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      setFilePath(url);
    } catch (error) {
      console.error('Error fetching file:', error);
    }
  };



  const handleDownload = () => {
    // Fetch the file path when the user clicks the "Download" button
    setDownloadLoading(true);
    fetchFilePath();
  };

  useEffect(() => {
    // Trigger download when filePath changes
    if (filePath !== '') {
      const downloadLink = document.createElement('a');
      downloadLink.href = filePath;
      downloadLink.download = data?.filename; // Set the desired filename here
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      setTimeout(() => {
        setDownloadLoading(false);
      } , 5000);
    }
  }, [filePath]);


  const handleRestore = async (value) => {    
    let path = {
      zip_path: value,
    }

    Swal.fire({
      title: 'Confirm Restoration',
      text: `Are you sure you want to restore the backup?. All changes performed after the backup date / time will be lost. Click on Restore button to proceed.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d5d5d5',
      confirmButtonText: 'Restore',
      width:"45%",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (value) {
          setLoading(true);
            axiosInstance.post(`/Auth/reset`,path)
            .then((res) => {
              if (res.data.status==true||res.status==200) {
                setTimeout(() => {
                  Toast.fire({
                    icon: "success",
                    title: res.data?.message || "Successfully restored",
                  });
                  fetcher()
                  setLoading(false);
                  logout()
                },40000)
                
              } else {
                setLoading(false);
                Toast.fire({
                  icon: "error",
                  title: res.data?.message || "Database not restored",
                });
              }
            })
            .catch((error) => {
              setLoading(false);
              Toast.fire({
                icon: "error",
                title: error?.response.data?.message || "Database not restored",
              });
            });
        }
      }
    })
  }
  

  const handleDelete = async (value,name) => {
    // let splitPath = value?.split(".").reverse()[0];
    let path = {
      file_path:value
    }
    Swal.fire({
      title: 'Are you sure?',
      text: `You want to Delete the ${name}? This  data will be permanently removed from the database.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d5d5d5',
      confirmButtonText: 'Delete',
      width:"30%",
    }).then(async (result) => {
      if (result.isConfirmed) {
        if (value) {
          await axiosInstance.post(`/Auth/delete_file`,path)
            .then((res) => {
              if (res.status==200) {
                Toast.fire({
                  icon: "success",
                  title: res.data?.message || "Successfully Deleted",
                });
                fetcher()
              } else {
                Toast.fire({
                  icon: "error",
                  title: res.data?.message || "File not Delete",
                });
              }
            })
            .catch((error) => {
              Toast.fire({
                icon: "error",
                title: error?.response.data?.message || "File not Delete",
              });
            });
        }
      }
    })
  }
  

  return (
    <>
      <div className="hover:drop-shadow-sm mr-2 py-2 px-[14px] rounded-3xl dropdown bg-white cursor-pointer relative">
        <svg
          className="m-auto w-[4px]"
          viewBox="0 0 4 15"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <ellipse cx="1.83391" cy="2.38902" rx="1.83" ry="1.82988" fill="#8C87A6" />
          <ellipse cx="1.83391" cy="7.30914" rx="1.83" ry="1.82988" fill="#8C87A6" />
          <ellipse cx="1.83391" cy="12.2293" rx="1.83" ry="1.82988" fill="#8C87A6" />
        </svg>
        <div className="hidden dropdown-menu z-[999]">
          <div
            id="modal"
            className="bg-transparent fixed inset-0 flex justify-center items-center"
          ></div>
          <div className="bg-white rounded-xl w-24 absolute -left-20 -top-1 z-[999]">
            <div className="grid p-1 rounded-t">
              { (GetRole()||GetAccess('admin_view'))  && (
                <span
                  className="p-1 hover:bg-navhover hover:rounded-lg cursor-pointer "
                  onClick={handleDownload}
                >
                  Download
                </span>
              )}
              {(GetRole()||GetAccess('admin_edit')) && (
                 
                <span
                  className="p-1  hover:bg-navhover hover:rounded-lg " 
                  onClick={() => {
                    handleRestore(data?.file_url);
                  }}
                >
                  Restore
                </span>
                
              )}
              {(GetRole()||GetAccess('backup_delete')) && (
                 
                 <span
                   className="p-1  hover:bg-navhover hover:rounded-lg" 
                   onClick={() => {
                     handleDelete(data?.file_url,data?.filename);
                   }}
                 >
                   Delete
                 </span>
                 
               )}
            </div>
          </div>
        </div>
      </div>

      {
        isLoading && (
          <Hourglass title={"Restore in progress…"} message={"After the restoration is complete, the system will automatically log out. Please log back in after 3 minutes."} />
        )
      }


{
        isDownloadLoading && (
          <Hourglass title={"Download in progress…"} message={"File is preparing for download, please wait ..."} />
        )
      }
    </>
  );
}

export default ViewMore;
